const BACKEND_URL = {
  production: 'https://api.medifriendrx.com',
  staging: 'https://api.staging.medifriendrx.com',
  dev: 'http://localhost:8080',
};

export const API_BASE = BACKEND_URL[process.env.REACT_APP_MEDIFRIEND] || BACKEND_URL.dev;
